import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import MockUpUtil from 'edge/api/gw-portals-util-js/MockUpUtil';
import MetadataDrivenUtil from 'edge/api/gw-portals-driven-ui-js/MetadataDrivenUtil';
import flowConfigUtil from 'edge/quoteandbind/common/util/FlowConfigUtil';

/**
 * This function prepares some common actions to be used in flow configuration
 *
 * @param {Object} dependencies
 * @param {Object} dependencies.$q a Promise implementation
 * @param {Object} dependencies.LoadSaveService
 * @param {Object} dependencies.ViewModelService
 * @param {Object} dependencies.ViewModelContext
 *
 * @returns {Object} a set of common Flow actions 'ret.ACTIONS' an their respective message 'ret.ACTIONS_MSG' to be used across all the custom flows
 */

const mockUpUtil = new MockUpUtil();

const fn = ($filter, $scope, $state, $stateParams, CustomQuoteService, $translate,
    ViewModelService, InsuranceSuiteMetadata, UserInfoService, ModalService) => {
    const ctrl = Object.create(BaseCtrl);



    ctrl.init = () => {
        $scope.isAdminorSuperuser = PSAUSER.isAdminorSuperuser;
        if (!PSAUSER.isAdminorSuperuser) {
            ModalService.showError('gateway.views.modal.Error', 'Permission Denied');
        }
        else {
            var deliveryDateDTO = {};
            $scope.submissionView = ViewModelService.create(deliveryDateDTO, 'pc', 'edge.capabilities.quote.submission.dto.DeliveryDateRuleDTO');
        }
    };
    $scope.$watch('submissionView.noOfDaysInThePast.value', (newValue) => {
        ctrl.changetoPositive
    });
    $scope.$watch('submissionView.noOfDaysInTheFuture.value', (newValue) => {
            ctrl.changetoPositive
        });
    $scope.$watch('submissionView.country.value', (newValue) => {
        ctrl.getNoOfdays();
    });
    ctrl.changetoPisitive = function(){
        if($scope.submissionView.noOfDaysInThePast.value <= 0 || $scope.submissionView.noOfDaysInTheFuture.value <= 0 ){
            $scope.submissionView.noOfDaysInThePast.value = 0;
            $scope.submissionView.noOfDaysInTheFuture.value = 0;
        }
    }
    ctrl.getNoOfdays = function () {
        var currentCountry = $scope.submissionView.country.value;
        if (currentCountry !== undefined && currentCountry !== "") {
            const operation = CustomQuoteService.getNoOfdays(currentCountry.code);
            operation.then((result) => {
                $scope.submissionView.noOfDaysInTheFuture = result.noOfDaysInTheFuture;
                $scope.submissionView.noOfDaysInThePast = result.noOfDaysInThePast;
                //No Days placeholder
                var isLabel = document.getElementById("noOfPlaceHolder");
                var isLabelFuture = document.getElementById("noOfFutureDaysPlaceHolder");
                if (!isLabel && !isLabelFuture) {
                    var noOfDaysMessage = $translate.instant('psa.quoteandbind.policy-information.noOfDaysInPast', {})
                    var noOfDaysInFutureMessage = $translate.instant('psa.quoteandbind.policy-information.noOfDaysInFuture', {})
                    var inputSelectorList = document.querySelectorAll("[type='number']");
                    for (let i = 0; i < inputSelectorList.length; i++) {
                        if (i == 0) {
                            inputSelectorList[i].insertAdjacentHTML('afterend',
                                '<label id="noOfPlaceHolder" ng-class="{\'gw-control-inline-label\': inline, \'gw-control-label\': !inline}" for="3" class=\"gw-control-label\" style=\'width:82%;padding:15px; \'><span ng-if="!tooltip" class="ng-binding ng-scope">' + noOfDaysMessage + '</span> </label>');
                        } else {
                            inputSelectorList[i].insertAdjacentHTML('afterend',
                                '<label id="noOfFutureDaysPlaceHolder" ng-class="{\'gw-control-inline-label\': inline, \'gw-control-label\': !inline}" for="3" class=\"gw-control-label\" style=\'width:82%;padding:15px; \'><span ng-if="!tooltip" class="ng-binding ng-scope">' + noOfDaysInFutureMessage + '</span> </label>');
                        }
                        inputSelectorList[i].style.width = "18%";
                        inputSelectorList[i].parentElement.style.border = "1px solid #373737";
                        inputSelectorList[i].style.border = "none";
                        inputSelectorList[i].style.height = "50px";
                        inputSelectorList[i].style.padding = "15\px";
                        console.log(inputSelectorList[i]);
                    }
                }
            }).catch((err) => {
              
            });
        }
    }
    ctrl.cancel = function () {
        //  flowModel.cancel(submissionVm, {withdraw: true});
        window.location.hash = "#/home"
    };
    ctrl.save = function (form) {
        form.submitted = true;
        if (form.invalid) {
            return;
        }
        var countryCode = $scope.submissionView.country.value.code;
        var noOfDays = $scope.submissionView.noOfDaysInThePast.value;
        var noOfDaysInFut = $scope.submissionView.noOfDaysInTheFuture.value;
        const operation = CustomQuoteService.updateDeliveryDateSetting(countryCode, noOfDays, noOfDaysInFut);
        operation.then((result) => {
            console.log(result);
            ModalService.showInfo('gateway.views.account-detail.Saved Title', 'gateway.views.account-detail.Saved Message');
        }).catch((error) => {
            ModalService.showError('gateway.views.modal.Error', 'quoteandbind.views.contact-us.Please contact us with the reference number below and we would be pleased to assist you.');
        });
        // flowModel.cancel(submissionVm, {savingDraft: true});
    };

    return ctrl.create($scope);
};

fn.$inject = ['$filter', '$scope', '$state', '$stateParams', 'qnb.CustomQuoteService', '$translate', 'ViewModelService', 'InsuranceSuiteMetadata', 'UserInfoService', 'ModalService'];
export default fn;
